/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Event from "../lib/Event";
//import FirebaseUtils from "lib/FirebaseUtils";
import PubSub from "../lib/PubSub";
import React from "react";
import { Link, withRouter } from "react-router-dom";
import _ from "underscore";
import {
  IonCard,
  IonCardContent,
  IonGrid,
  IonCol,
  IonRow,
  IonButton,
  IonIcon,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonContent,
  IonList,
  IonListHeader,
  IonLabel,
  IonItem,
  IonFooter,
} from "@ionic/react";

import {
  add,
  addOutline,
  close,
  closeOutline,
  heart,
  heartOutline,
  remove,
  removeOutline,
  trash,
} from "ionicons/icons";
import StringUtils from "../lib/StringUtils";
import MealDetailContent from "./MealDetailContent";
import { Capacitor } from "@capacitor/core";
import MealDetailContentV2 from "./MealDetailContentV2";

class MealDetailModalV2 extends React.Component<{
  presentingElement: any;
  showQuantity?: boolean;
  id?: string;
  showReview?: boolean;
  nativeMode?: boolean;
  allowFavorite?: boolean;
  favorites?: any;
  onFavoriteChange?: any;
  onQuantityChange?: any;
  editQuantity?: boolean;
  disableAdd?: boolean;
  quantity?: number;
}> {
  state: any = {};

  modalRef: any = React.createRef();

  setQuantity(meal: any, increment: number) {
    if (!meal) {
      return;
    }

    meal.quantity = Math.max(0, (meal.quantity || 0) + increment);

    this.setState(
      {
        meal,
      },
      () => {
        if (typeof this.props.onQuantityChange == "function") {
          this.props.onQuantityChange(meal, increment);
        }
      },
    );
  }

  componentDidMount() {
    PubSub.subscribe(Event.MEAL.OPEN_INFO, (data: any) => {
      const { id, meal } = data;

      if (
        (this.props.id && id != this.props.id) ||
        !meal ||
        meal?._id == this.state.meal?._id
      ) {
        return;
      }

      this.setState(
        {
          meal,
        },
        () => {
          if (meal) {
            this.modalRef?.current?.present();
          }
        },
      );
    });

    this.modalRef.current?.onDidDismiss().then(() => {
      this.setState({ meal: null });
    });
  }

  render() {
    return (
      <>
        <IonModal
          className="modal-mealdetail"
          ref={this.modalRef}
          canDismiss={true}
          mode={
            !this.props.nativeMode
              ? "ios"
              : Capacitor.getPlatform() == "ios"
              ? "ios"
              : "md"
          }
        >
          <IonHeader>
            <IonToolbar
              mode={
                !this.props.nativeMode
                  ? "ios"
                  : Capacitor.getPlatform() == "ios"
                  ? "ios"
                  : "md"
              }
              className={
                Capacitor.isNativePlatform()
                  ? "box-modal-toolbar-native"
                  : "box-modal-toolbar-web"
              }
              style={{ borderBottom: "none" }}
            >
              {this.props.allowFavorite ? (
                <IonButtons slot="start">
                  <IonButton
                    color="light"
                    onClick={() => {
                      this.props.onFavoriteChange(
                        this.state.meal,
                        !this.props.favorites?.includes(this.state.meal?._id),
                      );
                    }}
                  >
                    <IonIcon
                      slot="icon-only"
                      color={
                        this.props.favorites?.includes(this.state.meal?._id)
                          ? "danger"
                          : "dark"
                      }
                      icon={
                        this.props.favorites?.includes(this.state.meal?._id)
                          ? heart
                          : heartOutline
                      }
                    ></IonIcon>
                  </IonButton>
                </IonButtons>
              ) : null}

              <IonTitle slot="start">{this.state.meal?.name}</IonTitle>
              <IonButtons slot="end">
                <IonButton
                  color="dark"
                  onClick={() => {
                    this.modalRef?.current?.dismiss();

                    this.setState({
                      meal: null,
                    });
                  }}
                >
                  <IonIcon slot="icon-only" icon={closeOutline}></IonIcon>
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            {/**
             * <div className="sticky top-[0px] w-[100%] pl-[1rem] pr-[0.5rem] py-[1rem] z-[99]">
              {" "}
              {/**  bg-orange-500 
              <div className="flex justify-between items-center">
                <h1 className="text-white text-lg m-0 font-weight-bold line-height-[1] opacity-[0]">
                  {this.state.meal?.name}
                </h1>
                <button
                  className="h-8 w-8"
                  color="dark"
                  onClick={() => {
                    this.modalRef?.current?.dismiss();

                    this.setState({
                      meal: null,
                    });
                  }}
                >
                  <IonIcon
                    slot="icon-only"
                    className="h-8 w-8 text-white"
                    icon={closeOutline}
                  ></IonIcon>
                </button>
              </div>
            </div>
             */}
            <MealDetailContentV2
              allowFavorite={this.props.allowFavorite}
              favorites={this.props.favorites}
              onFavoriteChange={this.props.onFavoriteChange}
              meal={this.state.meal}
              showReview={this.props.showReview}
              nativeMode={this.props.nativeMode}
              modalID="webapp-mealselection-detailmodal"
              presentingElement={this.props.presentingElement}
            ></MealDetailContentV2>
          </IonContent>
          {this.props.showQuantity ? (
            <>
              {this.props.editQuantity ? (
                <>
                  <IonFooter
                    className={`ion-padding border-t-[1px] border-solid border-gray-100 bg-white`}
                  >
                    <div
                      style={{
                        paddingBottom: "var(--ion-safe-area-bottom, 0)",
                      }}
                    >
                      {this.state.meal?.quantity ? (
                        <div
                          className={`d-flex rounded-lg bg-orange-500 border-[1px] border-orange-700 w-full px-3 h-[45px] justify-center items-center`}
                        >
                          <div
                            className="pr-[0.4rem] cursor-pointer"
                            onClick={() => {
                              this.setQuantity(this.state?.meal, -1);
                            }}
                          >
                            <div className="d-flex text-center ion-align-items-center">
                              <div>
                                {this.state.meal?.quantity == 1 ? (
                                  <IonIcon
                                    className="text-white text-xl relative top-[2px]"
                                    icon={trash}
                                  ></IonIcon>
                                ) : (
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="26"
                                    height="26"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="text-white"
                                  >
                                    <path d="M5 12h14" />
                                  </svg>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="grow">
                            <div className="text-white font-bold text-lg text-center m-0">
                              {this.state?.meal?.quantity} In Box
                            </div>
                          </div>
                          <div
                            className="pl-[0.4rem]"
                            onClick={() => {
                              if (
                                !this.props.disableAdd &&
                                !this.state.meal?.outOfStock
                              ) {
                                this.setQuantity(this.state?.meal, 1);
                              }
                            }}
                            style={{
                              cursor:
                                this.props.disableAdd ||
                                this.state.meal?.outOfStock
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <div className="d-flex text-center items-center">
                              <div style={{ lineHeight: 1 }}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className={`${
                                    this.props.disableAdd ||
                                    this.state.meal?.outOfStock
                                      ? "text-orange-400"
                                      : "text-white"
                                  }`}
                                >
                                  <path d="M5 12h14" />
                                  <path d="M12 5v14" />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="flex w-[100%]">
                          <button
                            type="button"
                            className={`rounded-lg flex gap-x-2 items-center justify-center  border-[1px]  h-[45px] w-full  border-[1px]  ${
                              this.props.disableAdd ||
                              this.state.meal?.outOfStock
                                ? "bg-[#F0F0F0] border-gray-200"
                                : "hover:bg-orange-700 bg-orange-500 border-orange-500"
                            }`}
                            style={{
                              boxShadow:
                                !this.props.disableAdd &&
                                !this.state.meal?.outOfStock
                                  ? "rgba(0, 0, 0, 0.15) 0px 2px 2px 0px"
                                  : "",
                            }}
                            onClick={() => {
                              if (
                                !this.props.disableAdd &&
                                !this.state.meal?.outOfStock
                              ) {
                                this.setQuantity(this.state?.meal, 1);
                              }
                            }}
                          >
                            {this.props.disableAdd ? (
                              <>
                                <span
                                  className={`text-lg ${
                                    this.props.disableAdd
                                      ? "text-gray-400"
                                      : "text-white"
                                  } font-semibold`}
                                >
                                  Order Is Full
                                </span>
                              </>
                            ) : (
                              <>
                                {this.state.meal?.outOfStock ? (
                                  <span
                                    className={`text-lg text-gray-400 font-semibold`}
                                  >
                                    Out of Stock
                                  </span>
                                ) : (
                                  <>
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="26"
                                      height="26"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      className="text-white"
                                    >
                                      <path d="M5 12h14" />
                                      <path d="M12 5v14" />
                                    </svg>
                                    <span className="text-lg text-white font-semibold">
                                      Add
                                    </span>
                                  </>
                                )}
                              </>
                            )}
                          </button>
                        </div>
                      )}
                    </div>
                  </IonFooter>
                </>
              ) : (
                <>
                  <IonFooter
                    className={`ion-padding border-t-[1px] border-solid border-gray-100 bg-white`}
                  >
                    <div
                      style={{
                        paddingBottom: "var(--ion-safe-area-bottom, 0)",
                      }}
                    >
                      {this.state.meal?.quantity ? (
                        <div className="flex w-[100%] gap-x-4">
                          <div
                            style={{ lineHeight: 1 }}
                            className="text-xl rounded-lg border-[1px] border-gray-100 text-center grow bg-white px-3 py-2 font-medium text-gray-900"
                          >
                            {this.state?.meal?.quantity} In Box
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </IonFooter>
                </>
              )}
            </>
          ) : null}
        </IonModal>
      </>
    );
  }
}

export default MealDetailModalV2;
